import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CollapsibleInfoItem from "./CollapsibleInfoItem";

const truncateContent = (content, maxLength = 100) => {
  if (content.length <= maxLength) return content;
  return content.substring(0, maxLength) + "…";
};

const EligibilityAgeError = () => {
  const navigate = useNavigate();
  const handleOnBack = () => navigate(-1);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => setIsExpanded(!isExpanded);

  const items = [
    {
      title: "How do I begin treatment?",
      content: {
        full: "Begin by scheduling an appointment. You’ll need to complete a short eligibility questionnaire as well as authorise our access to your NHS Summary Care record. Together with you, your doctor will review your medical history and assess your suitability for treatment. Afterwards, your case will be submitted to a specialised medical team for further review and assessment. If approved, we will issue your prescription for your approval. The entire process normally takes between 2-5 days. Once we receive your approval and payment, your prescription will be sent to your nominated pharmacy for dispatch.",
        short: "",
      },
    },
    {
      title: "I'm having some technical issues",
      content: {
        full: "We’re sorry to hear that! Please reach out to our support staff for assistance.",
        short: "",
      },
    },
    {
      title: "Where can I find mental health support resources?",
      content: {
        full: "Feeling stressed, anxious, or depressed can significantly impact various aspects of life, including physical health, work, relationships, and overall well-being. It’s crucial to remember that you are not alone and that support is available. Taking the first step to seek help is a courageous act and can lead to positive changes and improved mental health. At Treat It Clinic, we understand the importance of accessing support when needed. However, it is important to note that our clinic is not an emergency service. If you or someone you know is in immediate crisis, please call 999. Remember, taking care of your mental health is essential for overall well-being. Don’t hesitate to reach out for support when needed. You deserve to feel better, and help is available.",
        short: "",
      },
    },
    {
      title: "How much will it cost?",
      content: {
        full: "Book an appointment for £69. Medication costs will vary according to your prescription. Please see our conditions page for more information. We accept credit/debit card payment. When booking an appointment or ordering a prescription, you will be taken to a checkout page to complete your transaction. We do not keep your credit card information on record.",
        short: "",
      },
    },
  ];

  items.forEach((item) => {
    item.content.short = truncateContent(item.content.full);
  });

  return (
    <div className="container d-flex flex-column justify-content-between h-100">
      <div className="row">
        <div className="col-md-12 col-lg-12 col-xl-10 px-0 py-0">
          <div className="d-flex flex-column justify-content-between">
            <h4 className="d-none d-md-block mb-2 fw-bold">
              Sorry, we are unable to proceed further.
            </h4>
            <h5 className="d-block d-md-none mb-2 fw-bold">
              Sorry, we are unable to proceed further.
            </h5>
            <p className="text-gray-1 mb-4">
              If you are under 18 and experiencing pain, we understand the
              importance of seeking medical support. Unfortunately we cannot
              provide consultations to those under 18.
            </p>
            <p className="my-3 fw-bold fs-6">Frequently asked questions</p>
            <div className="px-3">
              {items.map((item, index) => (
                <CollapsibleInfoItem
                  key={index}
                  title={item.title}
                  content={item.content}
                  isExpanded={isExpanded}
                  handleToggle={handleToggle}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="column d-flex flex-row justify-content-center justify-content-md-end align-items-center">
        <div className="d-flex flex-column-reverse flex-md-row footer-div px-5 px-md-0 py-4 py-md-0">
          <button
            className="text-primary-600 bg-transparent w-100 w-md-fit h-fit fw-bold border-0 rounded text-nowrap"
            onClick={handleOnBack}
          >
            <p className="mb-0 fw-bold fs-6">Back</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default EligibilityAgeError;
